import React from 'react';

const SocialProof = () => {
  return (
    <section data-testid="social-proof-section" className="bg-black py-6 border-y border-white/10">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-14">
          <div className="flex items-center gap-6">
            <img src="https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/t490eo40_essex-wedding-awards-winner-logo-2026.png" alt="Essex Wedding Awards Winner 2026" className="h-12 w-auto opacity-90 hover:opacity-100 transition-opacity" />
            <img src="https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/6c9sworo_badge-weddingawards_en_GB_edited.png" alt="Hitched Wedding Awards 2026" className="h-12 w-auto opacity-90 hover:opacity-100 transition-opacity" />
            <img src="https://image.bridebook.com/badge/platinum-2026-uk@v1.png" alt="Bridebook Platinum 2026" className="h-12 w-auto opacity-90 hover:opacity-100 transition-opacity" />
          </div>
          <div className="hidden md:block w-px h-8 bg-white/20" />
          <div className="flex items-center gap-8 text-white/70 text-sm">
            <div className="text-center">
              <div className="text-gold font-bold text-xl">1000+</div>
              <div>Happy couples</div>
            </div>
            <div className="text-center">
              <div className="text-gold font-bold text-xl">10+</div>
              <div>Years experience</div>
            </div>
            <div className="text-center">
              <div className="text-gold font-bold text-xl">5.0</div>
              <div>Average rating</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
